module.exports = __webpack_public_path__ + "static/media/medal_level9.2dfb7747.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/levels/medal_level9.png
// module id = 306
// module chunks = 0